(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionTypeMultipleChoiceController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        /**
         * @property {{
         *      ODDQuestionChoices: [ODDQuestionChoice]
         * }} boxModel
         * @property {{
         *      ODDQuestionChoiceID
         * }} ODDQuestionChoice
         */

        $scope.ctxtCtrl.allowMultiSelect = $scope.getQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'AllowMultiSelect') === 'true';
        $scope.ctxtCtrl.allowComment = $scope.getQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'AllowComment') === 'true';
        $scope.ctxtCtrl.forceComment = $scope.getQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'ForceComment') === 'true';
        $scope.ctxtCtrl.specifyAnswer = $scope.getQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'SpecifyAnswer') === 'true';

        $scope.ctxtCtrl.newChoice = {};

        $scope.allowMultiSelectChanged = function () {
            $scope.setQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'AllowMultiSelect', String.valueOf()($scope.ctxtCtrl.allowMultiSelect));
        };

        $scope.allowCommentChanged = function () {
            if (!$scope.ctxtCtrl.allowComment) {
                $scope.ctxtCtrl.forceComment = false;
                $scope.setQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'ForceComment', 'false');
            }

            if ($scope.ctxtCtrl.allowComment) {
                // Set the SpecifyAnswer to False
                $scope.ctxtCtrl.specifyAnswer = false;
                $scope.setQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'SpecifyAnswer', 'false');
            }
            
            $scope.setQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'AllowComment', String.valueOf()($scope.ctxtCtrl.allowComment));
        };

        $scope.forceLastAnswerSpecification = function () {
            if ($scope.ctxtCtrl.specifyAnswer) {
                $scope.ctxtCtrl.allowComment = false;
                $scope.allowCommentChanged();
            }
            $scope.setQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'SpecifyAnswer', String.valueOf()($scope.ctxtCtrl.specifyAnswer));
        };

        $scope.forceCommentChanged = function () {
            $scope.setQuestionAttributeValue($scope.boxModel.ODDQuestionAttributeValues, 'ForceComment', String.valueOf()($scope.ctxtCtrl.forceComment));
        };

        $scope.updateMultipleChoiceQuestion = function () {
            var oldQuestion = $scope.boxModel;

            $scope.updateQuestion().then(function (question) {
                if (question) {
                    // question choice are recreated between updates.
                    // we must keep $$hashkey to prevent ng-repeat animations.
                    question.ODDQuestionChoices.forEach(function (choice) {
                        choice.$$hashKey = _.get(_.find(oldQuestion.ODDQuestionChoices, {TitleEN: choice.TitleEN}), '$$hashKey');
                    });
                }
            });
        };
    }
})();